import React from 'react'
import Topheader from '../../Home/topHeader/Topheader'
import Middlebar from '../../Home/middleBar/Middlebar'
import NavMenu from '../../Home/navigationBar/NavMenu'
// import Navbar from '../../Home/navigationBar/Navbar'
import Footer from '../../Home/footer/Footer'
// import AccordionCard from './AccordionCard'
// import Accordian from '../accordion/Accordian'
import { Link } from "react-router-dom";
import AccordionCard from './AccordionCard'

export default function ADPCommerce() {
  return (
    <>
    <Topheader/>
    <Middlebar/>
    <NavMenu/>
    {/* <Navbar/> */}
      <div className="  bg-gray-200 items-center justify-center  ">
        <div className="banner">
            <img src='/ADPBC.png' 
             alt='BBA 4 YEARS'
             className='w-full h-80 '/>
        </div>
        <div className="content bg-gray-200  justify-items-center">
          <div className="mx-28">
               <h1 className='text-5xl font-bold mt-20 font-poppins text-red-800'>Course Detail</h1>

               <p className=" text-justify mt-4 mb-5 ">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Facere corporis quo nam velit voluptas eum quam adipisci pariatur. 
                Porro amet et itaque molestiae labore aliquam expedita nostrum. 
                Fuga, accusamus delectus?
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Facere corporis quo nam velit voluptas eum quam adipisci pariatur. 
                Porro amet et itaque molestiae labore aliquam expedita nostrum. 
                Fuga, accusamus delectus?
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Facere corporis quo nam velit voluptas eum quam adipisci pariatur. 
                Porro amet et itaque molestiae labore aliquam expedita nostrum. 
                Fuga, accusamus delectus?
               </p>
               
               <h3 className=" font-semibold text-sm">ADP COMMERCE Students learn to</h3>
               <ul className='list-disc mx-7 mt-2 mb-3 text-sm'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ul>

               <h3 className=" font-semibold text-base mt-5 ">Learning Outcomes for ADP COMMERCE Students include:</h3>
               <ol className='list-decimal mx-7 mt-2 text-sm mb-5'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ol>

               <h1 className="text-2xl font-bold  font-poppins text-red-800">Eligibility Criteria</h1>
               <p className=" text-justify text-sm mt-2 mb-5 ">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Facere corporis quo nam velit voluptas eum quam adipisci pariatur. 
                Porro amet et itaque molestiae labore aliquam expedita nostrum. 
                Fuga, accusamus delectus?
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Facere corporis quo nam velit voluptas eum quam adipisci pariatur. 
                Porro amet et itaque molestiae labore aliquam expedita nostrum. 
                Fuga, accusamus delectus?
               </p>
          </div>
          <div className='mt-10 mb-10'>
            <AccordionCard/>
          </div>
        </div>
        <div className=' pb-20'>
        <div >
       <Link to="/ApplyNow"><button className="mx-28 w-80 h-14 rounded-md text-white bg-maroon  font-bold text-3xl">APPLYNOW</button></Link> 
      </div>

        </div>
      </div>
    <Footer/>  
    </>
  )
}
